<script setup>
import {ref} from "vue";
import useMarkdown from "../../../../../frontend/src/composables/useMarkdown";
import elasticAiConversationsService from "@/services/elastic-ai-conversations.service";

const md = useMarkdown();

const showModal = ref(false);
const conversationId = ref(null);
const rounds = ref([]);
const roundsData = ref([]);
const title = ref('');

async function getInfo() {
    const {data} = await elasticAiConversationsService.getConversationInfo(conversationId.value);

    rounds.value = data.rounds;
    roundsData.value = data.rounds_data;
    title.value = data.title;
}

function open(id) {
    conversationId.value = id;
    rounds.value = [];
    roundsData.value = [];
    title.value = '';
    showModal.value = true;

    getInfo();
}

defineExpose({
    open
});
</script>

<template>
    <b-modal v-model="showModal" :title="title" hide-footer modal-class="modal-w-lg">
        <div class="modal-ai-chat__content" ref="content">
            <div class="ai-chat__inner">
                <div
                    v-for="(round, index) in rounds"
                    :key="index"
                    class="ai-chat"
                >

                    <div class="ai-chat__user">
                        {{round.question}}
                    </div>

                    <div class="ai-chat__machine">
                        <div v-html="md.render(round.answer)"></div>
                    </div>
                </div>

                <table v-if="roundsData.length">
                    <thead>
                    <tr>
                        <th v-for="key in Object.keys(roundsData[0])" :key="key">
                            {{key}}
                        </th>
                    </tr>
                    </thead>

                    <tbody>
                    <tr v-for="(roundData, index) in roundsData" :key="index">
                        <td v-for="(value, key) in Object.keys(roundData)" :key="key">
                            {{roundData[key]}}
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </b-modal>
</template>

<style scoped>

</style>
